(function() {
// Video handler
function setClickHandler(id, fn) {
  document.getElementById(id).onclick = fn
}

setClickHandler('video_container', function (e) {
  var className = e.target.className
  if (~className.indexOf('youtube')) {
    BigPicture({
      el: e.target,
      ytSrc: e.target.getAttribute('ytSrc'),
    })
  }
})
})()